__turbopack_context__.v({
  "contentContainer": "Option-module__7Q6coa__contentContainer",
  "leftContent": "Option-module__7Q6coa__leftContent",
  "optionContent": "Option-module__7Q6coa__optionContent",
  "rightContent": "Option-module__7Q6coa__rightContent",
});
